import { ProductType } from "../core/types";
import { BaseWidget } from "./BaseWidget";
import { ModalCoordinator } from "../modal/ModalCoordinator";

function cssRule(property: string, value: string | null | undefined): string {
    return value ? `${property}: ${value};` : '';
}

export class CtaWidget extends BaseWidget {

    private get isCalculator(): boolean {
        return this.contentContainer.productType === ProductType.CALCULATOR;
    }

    private get styles() {
        return this.isCalculator
            ? this.config.styles.calculator
            : this.config.styles.form;
    }

    private get copy() {
        return this.isCalculator
            ? this.config.copy.calculator
            : this.config.copy.form;
    }

    private get productTypeClass(): string {
        return this.isCalculator
            ? 'selectfi-cta-widget--calculator'
            : 'selectfi-cta-widget--form';
    }

    private get secondaryText(): string {
        if (this.copy.secondaryText == null) {
            return '';
        }
        return `<span class="selectfi-cta-widget__secondary">${this.copy.secondaryText}</span>`;
    }

    inject(): void {
        const s = this.styles;
        const selector = `.selectfi-cta-widget.${this.productTypeClass}`;

        this.contentContainer.element.innerHTML = `
<style>
    .selectfi-cta-widget {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        min-height: 45px;
        width: 100%;
        height: 100%;
    }
    .selectfi-cta-widget__primary {
        font-weight: 600;
        line-height: 1.3;
    }
    .selectfi-cta-widget__secondary {
        font-weight: 400;
        opacity: 0.85;
        margin-top: 2px;
    }
    ${selector} {
        ${cssRule('background-color', s.backgroundColor)}
        ${cssRule('color', s.textColor)}
        ${cssRule('margin-top', s.marginTop)}
        ${cssRule('margin-bottom', s.marginBottom)}
        ${cssRule('padding', s.padding)}
        ${cssRule('border', s.border || "none")}
        ${cssRule('border-radius', s.borderRadius)}
        ${s.ctaCustomCss ?? ''}
    }
    ${selector} .selectfi-cta-widget__primary {
        ${cssRule('font-size', s.primaryFontSize)}
    }
    ${selector} .selectfi-cta-widget__secondary {
        ${cssRule('font-size', s.secondaryFontSize)}
    }
    ${selector}:hover {
        ${cssRule('color', s.hoverFontColor)}
        ${cssRule('background-color', s.hoverBackgroundColor)}
    }
</style>
<button class="selectfi-cta-widget ${this.productTypeClass}">
    <span class="selectfi-cta-widget__primary">${this.copy.primaryText}</span>
    ${this.secondaryText}
</button>
`;

        this.contentContainer.element.addEventListener('click', () => {
            ModalCoordinator.getInstance().open(
                this.dealerKey,
                this.options,
                this.contentContainer,
                this.iframeProvider
            );
        });
    }
}